var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1469_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3464 14.1765C32.8151 13.4538 32.3596 12.9785 32.0728 12.4161C31.4317 11.1619 31.7916 9.8093 32.8825 8.89256C33.861 8.07706 35.3989 7.91114 36.3717 8.81663C38.621 10.9201 40.8338 13.0966 42.9312 15.3604C43.994 16.5049 43.8197 17.9812 42.6894 19.1539C40.8056 21.1111 38.8891 23.0364 36.9397 24.9299C35.5339 26.2966 33.9566 26.3359 32.697 25.1549C31.4374 23.9738 31.4346 22.3568 32.7897 20.8102C32.9331 20.6471 33.0709 20.4784 33.3352 20.169H10.1001V43.6753H35.5423C35.6349 43.0689 35.7607 42.4681 35.9191 41.8755C36.1042 41.2673 36.4885 40.7391 37.0103 40.3759C37.532 40.0127 38.1608 39.8357 38.7953 39.8733C40.0802 39.9464 41.3848 40.8829 41.4804 42.1455C41.6218 43.5821 41.5373 45.0319 41.2302 46.4424C40.755 48.349 38.8966 49.6285 36.92 49.6341C27.5049 49.6585 18.0897 49.6585 8.67461 49.6341C7.48794 49.6162 6.35443 49.1388 5.51235 48.3024C4.67028 47.4659 4.18523 46.3355 4.15917 45.1488C4.11231 36.3376 4.11231 27.5264 4.15917 18.7152C4.17604 16.1365 6.36628 14.1877 9.07948 14.1821C16.5752 14.1652 24.071 14.1821 31.5723 14.1821L33.3464 14.1765Z",
    fill: "url(#paint0_linear_1469_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1249 35.8466C24.6198 36.4315 24.9459 36.7577 25.2046 37.1289C26.1099 38.4337 25.9694 39.8679 24.856 40.9421C23.7426 42.0163 22.1962 42.1682 21.0547 41.1108C18.856 39.0777 16.7304 36.9574 14.6779 34.7752C13.6067 33.6335 13.6855 32.1009 14.7679 30.9704C16.7435 28.9082 18.7623 26.8854 20.8241 24.9019C22.064 23.7096 23.6891 23.7546 24.8503 24.8738C26.0818 26.0577 26.1156 27.624 24.9403 29.0132C24.7407 29.2494 24.5326 29.48 24.2009 29.8568H47.4416V6.34498H21.9966C21.9066 6.82585 21.8419 7.36858 21.7013 7.89163C21.2965 9.39329 19.9947 10.3213 18.5945 10.1413C17.8861 10.0791 17.2263 9.75507 16.7439 9.23252C16.2614 8.70997 15.991 8.02638 15.9853 7.31515C15.9319 5.54916 15.7407 3.74942 17.0088 2.22527C17.9591 1.08356 19.1147 0.377733 20.6189 0.377733C29.9871 0.377733 39.3554 0.349612 48.7349 0.377733C49.3468 0.36986 49.9541 0.484168 50.5212 0.713959C51.0883 0.943751 51.6039 1.2844 52.0378 1.71598C52.4716 2.14756 52.815 2.66137 53.0479 3.22734C53.2807 3.79331 53.3983 4.40006 53.3938 5.01205C53.4369 13.7276 53.4369 22.4451 53.3938 31.1645C53.3938 33.8247 51.2063 35.8325 48.4566 35.8382C40.9608 35.855 33.4651 35.8382 25.9637 35.8382L24.1249 35.8466Z",
    fill: "url(#paint1_linear_1469_3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1469_3",
    x: 0.672227,
    y: 0.365234,
    width: 56.2053,
    height: 56.1907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.882353 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1469_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1469_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1469_3",
    x1: 23.8821,
    y1: 8.20605,
    x2: 23.8821,
    y2: 49.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1469_3",
    x1: 33.6701,
    y1: 0.365234,
    x2: 33.6701,
    y2: 41.8303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImage1);
export default __webpack_public_path__ + "static/media/FeatureImage1.cdf61ec90137964927f1f00d69387e4c.svg";
export { ForwardRef as ReactComponent };